<div [id]="idModal" class="modal fade" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Importar Representantes
                    </h4>        
                </div>
                <div class="modal-body">
                    <form #form="ngForm" novalidate>
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="tagImportacao" class="col-form-label">Nome da Importação</label>
                                <input type="text" class="form-control" [(ngModel)]="tagImportacao" name="tagImportacao" id="tagImportacao"
                                    #tagImportacaoInput="ngModel" required="required" maxlength="100">
                                <p class="form-text text-muted">Serve para identificar a origem da importação posteriormente</p>                                    
                                <sgt-form-control-error
                                    *ngIf="tagImportacaoInput.errors && tagImportacaoInput.errors.required && tagImportacaoInput.dirty"
                                    msgError="O nome da importação é obrigatório">
                                </sgt-form-control-error>
                                <sgt-form-control-error
                                    *ngIf="tagImportacaoInput.errors && tagImportacaoInput.errors.maxlength"
                                    msgError="O nome da importação deve ter no máximo 100 caracteres">
                                </sgt-form-control-error>                                    
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12">
                                <span class="btn btn-light btn-file" [class.disabled]="uploader.isUploading">
                                    Selecione o arquivo <input type="file" name="uploadfile" #inputFile accept="text/csv, .csv" ng2FileSelect [uploader]="uploader" [disabled]="uploader.isUploading"/>
                                </span>
                                {{fileName}}                                
                            </div>
                        </div>
                    </form>
                    <div class="alert alert-danger alert-error" role="alert" *ngIf="error">
                        <div id="messageError">
                            <p >{{error.message}}</p>
                            <p>Causa: {{error.cause}}</p>
                        </div>
                    </div>                                
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="import()" id="btnImport" [disabled]="form.invalid || !fileName">
                        Importar
                    </button>
                    <button type="button" class="btn btn-light" (click)="close()">
                        Cancelar
                    </button>
                </div>            
            </div>
        </div>
    </div>